export default "__VITE_ASSET__DbrC2Gg7__"